import React, { useState } from 'react';
import { Avatar, Badge, Flex, Typography, Button, Skeleton } from 'antd';
import IntlMessage from '../../../components/IntlMessage';
import ChangePasswordForm from './FormPassword';
import { useSelector } from 'react-redux';

const { Text } = Typography;
const AccountHeader = (props) => {
  const { account } = props;
  const [isShowModalPassword, setIsShowModalPassword] = useState(false);
  const isMobile = window.innerWidth < 576;

  const openModalChangePassword = () => {
    setIsShowModalPassword(true);
  };
  const onModalClose = () => {
    setIsShowModalPassword(false);
  };

  return (
    <>
      <div className="gx-profile-banner">
        {!account ? (
          <Skeleton
            avatar
            paragraph={{ rows: 2, width: 100 }}
            active></Skeleton>
        ) : (
          <Flex
            vertical={isMobile}
            align={isMobile ? 'center' : null}
            justify={isMobile ? 'center' : null}>
            <div className="gx-profile-banner-avatar">
              <Avatar
                size={150}
                alt="..."
                src={account?.image ? account?.image : ''}
              />
            </div>
            <Flex align="flex-start" gap={12} vertical justify="center">
              <Flex align="center" gap={12}>
                <Text
                  style={{ color: '#fff', fontSize: 24 }}
                  className="gx-mb-2 gx-mb-sm-3 gx-fs-xxl gx-font-weight-light">
                  {account?.title}
                </Text>
                <Badge
                  size="default "
                  status={account?.status === true ? 'success' : 'error'}
                />
              </Flex>
              <Text style={{ color: '#fff' }} className="gx-mb-0 gx-fs-lg">
                {account?.short_name}
              </Text>
              <Button
                htmlType="button"
                onClick={openModalChangePassword}
                type="primary">
                {<IntlMessage id="global.changepassword" />}
              </Button>
            </Flex>
          </Flex>
        )}
      </div>
      {isShowModalPassword && (
        <ChangePasswordForm
          isShowModalPassword={isShowModalPassword}
          onModalClose={onModalClose}
        />
      )}
    </>
  );
};

export default AccountHeader;
